import { action } from 'typesafe-actions';
import { RouteComponentProps } from 'react-router';

import { IKnmListFilterParams } from 'APIPackage/KnmListModule/interfaces/IKnmListFilterParams';
import { IKnmLink } from 'APIPackage/KnmModule/interfaces/IKnmLink';
import { IKnmRequirementsNpa248 } from 'APIPackage/KnmModule/interfaces/IKnmRequirementsNpa248';
import { IKnmRequirementsNpa } from 'APIPackage/KnmModule/interfaces/IKnmRequirementsNpa';
import { IKnmEvent248 } from 'APIPackage/KnmModule/interfaces/IKnmEvent248';
import { IKnmObject248 } from 'APIPackage/KnmModule/interfaces/IKnmObject248';
import { IKnmSubject248 } from 'APIPackage/KnmModule/interfaces/IKnmSubject248';
import { IKnmErknmFormSubject } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormSubject';
import { ICreatePreventionForm } from 'PreventionPackage/MainModule/interfaces/ICreatePreventionForm';

import { KnmPmActionsEnum } from '../enums/KnmPmActionsEnum';
import { IKnmPmForm } from '../interfaces/IKnmPmForm';
import { IKnmPmPlanKnmSelectOption } from '../../PmReasonsModule/interfaces/IKnmPmPlanKnmSelectOption';
import { KnmPmPlanKnmMessageTypesEnum } from '../enums/KnmPmPlanKnmMessageTypesEnum';
import { IErknmStatusHintField } from '../../../KnmPackage/MainModule/interfaces/IErknmStatusHintField';

export const knmPmSetInitialFormValues = (initialFormValues: IKnmPmForm) =>
  action(KnmPmActionsEnum.KNM_PM_SET_INITIAL_FORM_VALUES, { initialFormValues });
export const knmPmResetInitialFormValues = () => action(KnmPmActionsEnum.KNM_PM_RESET_INITIAL_FORM_VALUES);
export const knmTryGenerateWarning = (id: string, isStatement: boolean) =>
  action(KnmPmActionsEnum.KNM_PM_TRY_GENERATE_WARNING, { id, isStatement });

export const knmPmGetPlanKnmSelectOptions = (
  filters: IKnmListFilterParams,
  callback: (options: IKnmPmPlanKnmSelectOption[] | undefined) => void,
) => action(KnmPmActionsEnum.KNM_PM_GET_PLAN_KNM_SELECT_OPTIONS, { filters, callback });
export const knmPmSetPlanKnmSelectOptions = (selectOptions: IKnmPmPlanKnmSelectOption[]) =>
  action(KnmPmActionsEnum.KNM_PM_SET_PLAN_KNM_SELECT_OPTIONS, { selectOptions });

export const knmPmOpenPlanKnmMessageModal = (type: KnmPmPlanKnmMessageTypesEnum, id: string) =>
  action(KnmPmActionsEnum.KNM_PM_OPEN_PLAN_KNM_MESSAGE_MODAL, { type, id });
export const knmPmClosePlanKnmMessageModal = () => action(KnmPmActionsEnum.KNM_PM_CLOSE_PLAN_KNM_MESSAGE_MODAL);
export const knmPmReloadParticipantByCancel = () => action(KnmPmActionsEnum.KNM_PM_RELOAD_PARTICIPANT_BY_CANCEL);
export const knmPmFillOrganizationsAndObjectsByOtherPassport = (
  value: {
    organizations: IKnmSubject248[];
    objects: IKnmObject248[];
    events: IKnmEvent248[] | null;
    requirements: IKnmRequirementsNpa248[] | IKnmRequirementsNpa[] | null;
  },
  link: IKnmLink,
) =>
  action(KnmPmActionsEnum.KNM_PM_FILL_ORGANIZATIONS_AND_OBJECTS_BY_OTHER_PASSPORT, {
    value,
    link,
  });
export const knmPmSetChoosenOrganizationsByOtherPassport = (organization: IKnmErknmFormSubject) =>
  action(KnmPmActionsEnum.KNM_PM_SET_CHOOSEN_ORGANIZATION_BY_OTHER_PASSPORT, {
    organization,
  });

export const pmSetOpenChangePmModal = (openChangePmModal: () => void) =>
  action(KnmPmActionsEnum.PM_SET_OPEN_CHANGE_PM_MODAL, { openChangePmModal });

export const knmPmCreateFromModal = (values: ICreatePreventionForm, history: RouteComponentProps['history']) =>
  action(KnmPmActionsEnum.KNM_PM_CREATE_FROM_MODAL, { values, history });

export const knmPmSetStatusHintText = (value: string | undefined) =>
  action(KnmPmActionsEnum.KNM_PM_SET_STATUS_HINT_TEXT, { value });
export const knmPmSetStatusHintFields = (fields: IErknmStatusHintField[]) =>
  action(KnmPmActionsEnum.KNM_PM_SET_STATUS_HINT_FIELDS, { fields });
export const knmPmSetWasFirstInit = (wasFirstInit: boolean) =>
  action(KnmPmActionsEnum.KNM_PM_SET_WAS_FIRST_INIT, { wasFirstInit });
